const lang = {
  logo: "Logo",
  save: "Enregistrer",
  cancel: "Annuler",
  project: "Projet",
  home: "Accueil",
  project_home: "Accueil projet",
  quotes: "Devis",
  quote: "Devis",
  offers: "Offres",
  proforma: "Offre confirmé",
  invoices: "Factures",
  index: "Pos",
  invoice: "Facture",
  clients: "Clients",
  download_customs_report: "Rapport douanier",
  download_tag: "Marquage",
  articles: "Articles",
  designation: "Désignation",
  qty: "Qté",
  u: "U",
  pu: "P.U",
  pt: "P.T",
  validity_date: "Date d'option",
  settings: "Paramètres",
  report_settings: "Paramètres du rapport",
  to_offer: "Convertir en offre",
  delete: "Supprimer",
  yes: "Oui",
  no: "Non",
  to_po: "Convertir en bon cmd",
  to_invoice: "Convertir en facture",
  tax: "Taxe",
  inquiry: "Demande",
  discount: "Remise",
  currency: "Devise",
  destination: "Destination",
  transport: "Transport",
  shipping: "Expédition",
  payment: "Paiement",
  time_period: "Période",
  language: "Langue",
  country: "Pays",
  project_list: "Liste des projets",
  ref: "Réf",
  project_name: "Nom du projet",
  project_n: "N° projet",
  internal_reference: "Réf. interne",
  name: "Nom",
  settings: "Paramètres",
  representatives: "Représentants",
  buyers: "Acheteurs",
  quotes: "Devis",
  offers: "Offres",
  suppliers: "Fournisseurs",
  representatives: "Représentants",
  setting: "Paramètres",
  user: "Utilisateur",
  bill: "Facture",
  new_advance: "Nouveau avance",
  new: "Nouveau",
  draft: "Brouillon",
  status: "Statut",
  date: "Date",
  client: "Client",
  search: "Rechercher",
  search_for_supplier: "Rechercher fournisseur",
  search_for_article: "Rechercher article",
  project_list: "Liste des projets",
  project_description: "Description",
  reference_required: "Référence requise",
  name_required: "Nom requis",
  project_priority: "Priorité du projet",
  to_do: "À faire",
  high_priority: "Priorité élevée",
  medium_priority: "Priorité moyenne",
  low_priority: "Priorité faible",
  payment_mode: "Mode de paiement",
  payment_date: "Date de paiement",
  warranty_note: "Note de garantie",
  currency: "Devise",
  transport_mode: "Mode de transport",
  shipping_mode: "Mode d'expédition",
  destination: "Destination",
  report_settings: "Paramètres du rapport",
  customs_reports: "Rapport douanière",
  hs_code: "Code HS",
  description: "Description",
  total_by_hs_code: "Total par HS code",
  total_qty: "Qté",
  total_amount: "Montant total",
  delivery_note: "Bon de livraison",
  delivery_time: "Délai de livraison",
  note: "Remarque",
  item: "Article",
  quantity: "Quantité",
  purchase_price: "Prix d'achat",
  margin: "Marge",
  selling_price: "Prix de vente",
  total_purchase: "Total achat",
  total_selling: "Total vente",
  sub_total: "Total EXW",
  discount: "Remise",
  tva: "TVA",
  transport_fee: "Frais de transport",
  shipping_fee: "Frais d'expédition",
  grand_total: "Total général",
  price: "Prix",
  new_quote: "Créer devis",
  new_offer: "Créer offre",
  offer: "Offre",
  tecknical_offer: "Offre technique",
  unpaid: "Non payé",
  dashboard: "Tableau de bord",
  purchase_orders: "Bons de commande",
  po: "Bon de commande",
  purchase_order: "Bon de commande",
  purchase_orders: "Bons de commande",
  pos_list: "Liste des Bons de commande",
  add_field: "Nouvelle ligne",
  add_item: "Nouveau élément",
  user: "Utilisateur",
  bill: "Facture",
  proforma_invoices: "Factures proforma",
  expense: "Dépense",
  jan: "Janv",
  feb: "Fév",
  mar: "Mars",
  apr: "Avril",
  may: "Mai",
  jun: "Juin",
  jul: "Juil",
  aug: "Août",
  sep: "Sept",
  oct: "Oct",
  nov: "Nov",
  dec: "Déc",
  monthly_average_for: "Moyenne mensuelle pour",
  balance: "Solde ",
  overdue: "En retard",
  paid: "Payé",
  proforma_invoices: "Factures proforma",
  pending: "En attente",
  sent: "Envoyé",
  declined: "Refusé",
  accepted: "Accepté",
  expired: "Expiré",
  priority: "Priorité",
  quotes_count: "Devis",
  pos_count: "Bons de commande",
  refresh: "Actualiser",
  add_new_project: "Ajouter un nouveau projet",
  offers_count: "Offers",
  proformas_count: "Offres confirmées",
  proformas: "Offres confirmées",
  invoices_count: "Factures",
  quotes_list: "Liste des devis",
  supplier: "Fournisseur",
  offer_list: "Liste des offres",
  proforma_list: "Liste des Offres confirmées",
  invoice_list: "Liste des factures",
  client_list: "Liste des clients",
  add_new_quote: "Ajouter un nouveau devis",
  add_new_po: "ajouter un nouveau bon de commande",
  add_new_offer: "Ajouter une nouvelle offre",
  add_new_proforma: "Ajouter une nouvelle proforma",
  add_new_invoice: "Ajouter une nouvelle facture",
  add_new_client: "Ajouter un nouveau client",
  add_new_article: "ajouter un nouvel article",
  default_purchase_price: "Prix d'achat par défaut",
  default_quantity: "Quantité par défaut",
  unit: "unité",
  supplier_list: "Liste des fournisseurs",
  supplier_ref: "Réf. fournisseur",
  supplier_name: "Nom. fournisseur",
  supplier_contact: "Contact. fournisseur",
  add_new_supplier: "Ajouter un nouveau fournisseur",
  representative_list: "Liste des représentants",
  add_new_representative: "Ajouter un nouveau représentant",
  first_name: "Prénom",
  last_name: "Nom de famille",
  email: "E-mail",
  phone: "Tél",
  phone_number: "Tél",
  company: "Société",
  website: "Site Web",
  address: "Adresse",
  comment: "commentaire",
  postal_code: "Code postal",
  city: "Ville",
  country: "Pays",
  last_update: "dernière modif",
  article_list: "Liste des articles",
  add_new_buyer: "Ajouter un nouvel acheteur",
  our_bank: "Notre Banque",
  incoterm: "Mise à",
  exceptional_discount: "Remise exceptionnelle",
  total_price_deducted: "Prix total EXW remise déduite",
  created_on: "créé le",
  representative: "Représentant",
  buyer: "Achteteur",
  show_rep: "Afficher le représentant",
  show_header: "Afficher l'en-tête",
  show_footer: "Afficher le pied",
  show_delivery_delay: "Afficher le délai de livraison",
  show_payment_mode: "Afficher le mode de paiement",
  show_payment_date: "Afficher la date de paiement",
  show_warranty_period: "Afficher le délai de garantie",
  warranty_period: "Délai de garantie",
  commission_list: "Liste des commissions",
  sales: "Ventes",
  commission: "Commission",
  weight_of_goods: "Poids des marchandises",
  volume: "Volume",
  nbr_of_pieces: "Nombre de pièces",
  total_weight: "Poids total",
  packing_list: "Liste de colisage",
  print: "Imprimer",
  factory_offer: "Offre usine",
  new_advance: "Nouveau avance",
  calculation: "Calcul",
  payment_advance_list: "Liste des avances de paiement",
  advance: "Avance",
  total_sales: "Total ventes",
  total_commission: "Total commissions",
  total_advances: "Total avances",
  remaining: "Restant",
  are_you_sure_you_want_to_delete: "Etes vous sur de vouloir supprimer ?",
  delete_confirmation: "Confirmation de suppression",
  our_ref: "N/Réf",
  client_ref: "V/Réf",
  confirm: "confirmer",
  new_supplier: "Fournisseur",
  new_article: "Article",
  download: "Télécharger",
  download_pdf: "Télécharger PDF",
  save_for_this_document: "Conserver pour ce document",
  no_files_uploaded: "Aucun fichier téléchargé",
  drag_or_upload: "Glissez ou importer",
  drag_drop_or_click_to_select_files:
    "Glissez-déposez ou sélectionnez des fichiers",
  delete_this_file_confirm: "Confirmer la suppression de ce fichier",

  // new

  global_margin: "Marge global",
  create_project: "Créer projet",
  choose_background_color: "Choisir la couleur de fond",
  introductory_message: "Message d’introduction",
  closing_message: "Message de clôture",
  signature: "Signature",
  notes: "Notes",
  send_by_mail: "Envoyer par mail",
  dears: "Messieurs",
  add_to_project: "Ajouter au projet",
  select_template: "Choisir une template",
  entity: "entité",
  update: "Modifier",
  received: "reçu",
  not_received: "non réçu",
};

export default lang;
